import React, { createContext, useCallback, useContext, useState } from 'react';

type UpdatePrefilledFieldsContextValue = {
  updatePrefilledField: (prefilledField: string) => void;
};
type PrefilledEmailContextValue = { isEmailPrefilled: boolean };
type PrefilledPhoneContextValue = { isPhonePrefilled: boolean };

const ApplyFormUpdatePrefilledFieldsContext = createContext<UpdatePrefilledFieldsContextValue | undefined>(undefined);
const ApplyFormPrefilledEmailContext = createContext<PrefilledEmailContextValue | undefined>(undefined);
const ApplyFormPrefilledPhoneContext = createContext<PrefilledPhoneContextValue | undefined>(undefined);

export const ApplyFormPrefilledTrackingProvider: React.FC = ({ children }) => {
  const [isEmailPrefilled, setIsEmailPrefilled] = useState(false);
  const [isPhonePrefilled, setIsPhonePrefilled] = useState(false);

  const updatePrefilledField = useCallback((prefilledField): void => {
    switch (prefilledField) {
      case 'email': {
        setIsEmailPrefilled(true);
        break;
      }
      case 'phone': {
        setIsPhonePrefilled(true);
        break;
      }
    }
  }, []);

  return (
    <ApplyFormUpdatePrefilledFieldsContext.Provider value={{ updatePrefilledField }}>
      <ApplyFormPrefilledEmailContext.Provider value={{ isEmailPrefilled }}>
        <ApplyFormPrefilledPhoneContext.Provider value={{ isPhonePrefilled }}>
          {children}
        </ApplyFormPrefilledPhoneContext.Provider>
      </ApplyFormPrefilledEmailContext.Provider>
    </ApplyFormUpdatePrefilledFieldsContext.Provider>
  );
};

export const useUpdatePrefilledFields = (): UpdatePrefilledFieldsContextValue => {
  const updatePrefilledFieldValue = useContext(ApplyFormUpdatePrefilledFieldsContext);

  if (typeof updatePrefilledFieldValue === 'undefined') {
    throw new Error('useDocsUploadProps must be used within an ApplyFormPrefilledTrackingContext');
  }

  return updatePrefilledFieldValue;
};

export const useIsEmailFieldPrefilled = (): PrefilledEmailContextValue => {
  const isEmailPrefilledValue = useContext(ApplyFormPrefilledEmailContext);

  if (typeof isEmailPrefilledValue === 'undefined') {
    throw new Error('useDocsUploadProps must be used within an ApplyFormPrefilledTrackingContext');
  }

  return isEmailPrefilledValue;
};

export const useIsPhoneFieldPrefilled = (): PrefilledPhoneContextValue => {
  const isPhonePrefilledValue = useContext(ApplyFormPrefilledPhoneContext);

  if (typeof isPhonePrefilledValue === 'undefined') {
    throw new Error('useDocsUploadProps must be used within an ApplyFormPrefilledTrackingContext');
  }

  return isPhonePrefilledValue;
};
